import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'nx-ng-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SelectComponent,
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectComponent implements ControlValueAccessor {
  @Input()
  id = '';
  @Input()
  label = '';
  @Input()
  placeholder = '';
  @Input()
  errorText = '';
  @Input()
  disabled = false;
  @Input()
  isPostcodeResults = false;

  @Output()
  select: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  blur: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  click: EventEmitter<void> = new EventEmitter<void>();

  private touched = false;

  private localValue = '';

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  set value(value: any) {
    this.localValue = value;
    this.onChange(value);
    this.select.emit(value);
  }

  get value(): any {
    return this.localValue;
  }

  onChange = (event: any) => {};
  onTouch = () => {};

  writeValue(value: any) {
    this.value = value;
    if (this.changeDetectorRef) {
      this.changeDetectorRef.markForCheck();
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  get errorId() {
    return `${this.id}-error`;
  }

  get hasError() {
    return this.errorText?.length > 0;
  }

  markAsTouched() {
    if (!this.touched) {
      this.touched = true;
      this.onTouch();
    }
  }

  handleBlur() {
    this.markAsTouched();
    this.blur.emit();
  }

  handleClick() {
    this.click.emit();
  }
}
